export default {
  shared: {
    recentTransactionsTitle: "Recent Transactions",
    recentTransactionsEmpty: "No transactions yet",
    recentTransactionsHint: "Your recent activity will appear here",
    loadingData: "Loading dashboard data...",
    errorLoad: "Error loading dashboard data",
    quickActions: "Quick Actions",
    title: "Dashboard",
    greetingWithName: "{{greeting}}, {{name}}!",
    wallet: "Wallet",
  },
  admin: {
    greetingWithName: "{{greeting}}, Staff!",
    overviewStats: "Platform overview and statistics",
    viewSellers: "View Sellers",
    viewSellersDesc: "Manage seller accounts",
    supportTickets: "Support Tickets",
    supportTicketsDesc: "Handle support requests",
    manageActivities: "Activities",
    manageActivitiesDesc: "Review and configure the catalog",
    manageStructures: "Structures",
    manageStructuresDesc: "Houses, hosts and kiosks",
    notificationsTitle: "Operational alerts",
    notificationsViewAll: "View all",
    notificationsLoading: "Loading alerts...",
    notificationsError: "Could not load alerts",
    notificationsEmpty: "No open alerts",
    notificationsMore: "{{count}} more — open inbox for full list",
    statTotalPlatformBalance: "Total Platform Balance",
    statTotalSellers: "Total Sellers",
    statActiveSellers: "{{count}} active",
    statTotalActivities: "Total Activities",
    statActiveActivities: "{{count}} active",
    statActivitiesBreakdown: "{{restaurants}} restaurants · {{services}} services",
    statTotalHouses: "Total Houses",
    statActiveHouses: "{{count}} active",
  },
  partner: {
    overview: "Overview of your business",
    sellerIdMissing: "Seller user ID not found",
    greeting: "Here's a summary of your business",
    myActivities: "My Activities",
    myActivitiesDesc: "Manage your services & menus",
    bookings: "Bookings",
    bookingsDesc: "View recent reservations",
    walletDesc: "Check your earnings",
    statsWalletBalance: "Wallet Balance",
    statsAmountOwed: "Amount owed",
    statsBookings30d: "Bookings (30d)",
    statsRevenue30d: "Revenue (30d)",
    statsTransactions30d: "Transactions (30d)",
    statsTrendVsPrev: "vs prev. 30d",
  },
  host: {
    myStructures: "My structures",
    myStructuresDesc: "Manage your houses and devices",
    walletDesc: "Check your commissions and payouts",
    overview: "Overview of your structures",
    hostIdMissing: "Host user ID not found",
    greeting: "Here's a summary of your structures",
  },
  salesAgent: {
    overview: "Sales agent overview",
    userIdMissing: "Sales agent user ID not found",
    loading: "Loading dashboard...",
    errorLoad: "Error loading dashboard",
    greeting: "Your commissions and assigned activities & structures",
    walletBalance: "Wallet balance",
    amountOwed: "Amount owed",
    lifetimeCredits: "Lifetime credits (commissions)",
    assignedScopes: "Assigned scopes",
    walletDesc: "Check your commissions and payouts",
    assignments: "Assignments",
    assignmentsDesc: "View activities and structures you earn on",
    support: "Support",
    supportDesc: "Get help or open a ticket",
  },
  customer: {
    welcomeTitle: "Welcome back!",
    welcomeDesc: "Track your restaurant receipts and loyalty points",
    myBookings: "My bookings",
    myBookingsDesc: "View and manage receipt uploads",
    pointsBalance: "Points balance",
    pointsCount: "{{count}} points",
  },
} as const;
